import { createFormHook, createFormHookContexts } from '@tanstack/react-form';
import z from 'zod';

import { CheckboxFieldV2 } from '../CheckboxField';
import { CustomDateFieldV2 } from '../CustomDateField';
import { DayMonthYearV2 } from '../DayMonthYear';
import { IconRadioGroupV2 } from '../IconRadioGroup';
import { PhoneNumberFieldV2 } from '../PhoneNumberField';
import { RadioField } from '../RadioField';
import { RangeSliderField } from '../RangeSliderField';
import { SelectField } from '../SelectField';
import { SubmitButton } from '../SubmitButton';
import { TextAreaField } from '../TextAreaField';
import { TextField } from '../TextField';
import { ToggleField } from '../ToggleField';

export const { fieldContext, useFieldContext, formContext, useFormContext } =
	createFormHookContexts();

export const { useAppForm, withForm } = createFormHook({
	fieldComponents: {
		CheckboxFieldV2,
		CustomDateFieldV2,
		DayMonthYearV2,
		IconRadioGroupV2,
		PhoneNumberFieldV2,
		RadioField,
		RangeSliderField,
		SelectField,
		TextField,
		TextAreaField,
		ToggleField,
	},
	formComponents: {
		SubmitButton,
	},
	fieldContext,
	formContext,
});

export const checkboxStringToBool = z.enum(['true', 'false']).transform((v) => v === 'true');
